var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"finished"},[_c('div',{staticClass:"tips"},[_vm._v("\n    "+_vm._s(_vm.success ? '认证成功' : '认证失败')+"，请关闭该页面！\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }